// 费用明细
// 仓储费

import { HttpGetWarecostList } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from 'vuex';
import comExcel from '@components/templates/excelalert';
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetWarecostList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/billingCostStorageDetailed/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    ).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList','getAdminTransferWarehouse', 'getCusproductList', 'getBillcusWareList']),
        ToolsData() {
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    key: 'EQ_orgId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    key: 'EQ_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.getAdminTransferWarehouse,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "账单",
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "库存类型",
                    key: 'EQ_inventoryType',
                    tag: 'vSelect',
                    options: [
                        { value: 'CAN_SALE', label: '可售库存' },
                        { value: 'NO_SALE', label: '不可售库存' },
                    ],
                },
                {
                    label: "批次号",
                    key: 'EQ_batchNo',
                    tag: 'vInput',
                },
                {
                    label: "项目",
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "SKU",
                    key: 'EQ_sku',
                    tag: 'vInput',
                },
                // {
                //     label: "状态",
                //     key: 'EQ_billId',
                //     more: true,
                //     tag: 'vSelect',
                //     options: this.getBillingDetailStatus,
                //     props: {
                //         filterable: true,
                //     },
                //     // on: {
                //     //     'on-change': function(value, label, attach = {}) {
                //     //         if(label=='已出账'){
                //     //             this.formData = {
                //     //                 ...this.formData,
                //     //                 'search[NE_billId]':0
                //     //             }
                //     //         }
                //     //     },
                //     // }
                //     // on: {
                //     //     'on-change': val => {
                //     //         console.log(val);
                //     //         if(val==1){
                //     //             this.key="NE_billId";
                //     //             this.val=0;
                //     //         }
                //     //     }
                //     // },
                //     // on: {
                //     //     'on-attach': (attach) => { this.formData.orgWarehouseCode = attach.code }
                //     // },
                //     // on: {
                //     //     'on-change': (val) => {
                //     //         // const data = this.productList.find(item => item.sku == val);
                //     //         this.boundFormData = { sku: val }
                //     //     }
                //     // },
                // },
                {
                    label: "快照日期",
                    tag: 'vDatepicker',
                    key: 'BT_snapshotAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [{
                title: '组织/仓库',
                render: (h, { row }) => {
                    let orgId = row.orgId
                    const { label } = this.getBillcusorgList.find(function (item) {
                        return item.value == orgId
                    }) || {};
                    return <div>
                        <div>{label || '--'}</div>
                        <div>{row.orgWarehouseCode || '--'}</div>
                    </div>
                }
            },
            {
                title: '账单',
                key: 'billNo',
                width: 130,
                render: (h, { row }) => {
                    return <div>
                        账单 : {row.billNo}
                        <div>状态:{row.billId == 0 ? '未出账' : '已出账'}</div>
                    </div>
                }
            },
            {
                title: '仓库类型/库存类型/SKU/项目',
                width: 180,
                render: (h, { row }) => {
                    let waretype, inventype;
                    let lineId = row.lineId
                    switch (row.warehouseType) {
                        case 1: waretype = '三方仓'; break;
                        case 2: waretype = 'FBA仓'; break;
                        case 3: waretype = '自营仓'; break;
                        case 4: waretype = 'onsite仓库'; break;
                    }

                    switch (row.inventoryType) {
                        case 'CAN_SALE': inventype = '可售库存'; break;
                        case 'NO_SALE': inventype = '不可售库存'; break;
                    }

                    const { label } = this.getCusproductList.find(function (item) {
                        return item.value == lineId
                    }) || {};
                    return <div>
                        <div>{waretype || '--'}</div>
                        <div>{inventype || '--'}</div>
                        <div>{row.sku || '--'}</div>
                        <div>{label || '--'}</div>
                    </div>
                }
            },
            {
                title: '批次号/存储天数',
                key: 'batchNo',
                width: 130,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.batchNo || '--'}</div>
                        <div>{row.storageDays}</div>
                    </div>
                },
            },
            {
                title: '库存',
                key: 'stock',
            },
            {
                title: '计费量*费率*计费系数',
                width: 160,
                key: 'billNum',
                render(h, { row }) {
                    let unit = {
                        "BILL_UNIT_UNKNOWN": '未知',
                        "BILL_UNIT_CUBIC_FOOT": '立方英尺',
                        "BILL_UNIT_CUBIC_METER": '立方米'
                    }
                    return <div>{row.billNum} {unit[row.unit]} * {row.rate} * {row.modulus}</div>
                }
            },
            {
                title: '总费用',
                key: 'totalCost',
                render(h, { row }) {
                    return `${row.totalCost} ${row.currency || 'USD'}`
                }
            },
            {
                title: "尺寸(cm*cm*cm)",
                key: "length",
                render(h, { row }) {
                    return `${row.length} * ${row.width} * ${row.height}`
                }
            },
            {
                title: '快照时间/创建时间',
                key: 'snapshotAt',
                width: 130,
                render(h, { row }) {
                    return <div>
                        {row.snapshotAt}
                        <div>{row.createdAt}</div>
                    </div>
                }
            }
            ];
        },
    },
};




